import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IoRemoveOutline } from "react-icons/io5";
const RemoveButton = ({ label = "Remove", onClick = () => {}, disabled = false }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(label)}>
      <span>
        <IconButton
          onClick={onClick}
          disabled={disabled}
          sx={{
            width: 40,
            height: 40,
            backgroundColor: "rgba(239, 68, 68, 0.15)",
            color: "#ef4444",
            "&:hover": {
              backgroundColor: "rgba(239, 68, 68, 0.25)",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(239, 68, 68, 0.05)",
              color: "rgba(239, 68, 68, 0.3)",
            },
            borderRadius: 2,
          }}>
          <IoRemoveOutline />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default RemoveButton;
